import React, { useState, useEffect } from 'react';

import axios from 'axios';
import { apiBase, getApiData } from './api';

// import CircleLoader from "react-spinners/CircleLoader";
import LoadingOverlay from 'react-loading-overlay-ts';



const FormData = require('form-data');

// // Save state
// sessionStorage.setItem('myState', JSON.stringify(state));

// // Load state
// const savedState = JSON.parse(sessionStorage.getItem('myState'));


const LoginPage = ({setIsLoggedIn, setIdToken, setRefreshToken}) => {
  const [username, setUsername] = useState(sessionStorage.getItem('auth-username'));
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [authChallengeParameters, setAuthChallengeParameters] = useState({});
  const [authChallengeSession, setAuthChallengeSession] = useState(null);
  const [passwordShouldBeSet, setPasswordShouldBeSet] = useState(false);
  const [challengePassword1, setChallengePassword1] = useState('');
  const [challengePassword2, setChallengePassword2] = useState('');

  const challengeUrl = `${apiBase()}/m/login_challenge`;
  const loginUrl = `${apiBase()}/m/login`;
  var authIdToken = '';
  var refreshToken = '';

  useEffect(() => {
    // Check session data on component mount
    authIdToken = sessionStorage.getItem('auth-id-token');
    
    if (authIdToken) {
      setIdToken(authIdToken);
    }

    refreshToken = sessionStorage.getItem('auth-refresh-token');
    if(refreshToken) {
      setRefreshToken(refreshToken);
    }
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    // Do something with the form values
    console.log(`Username: ${username}, Password: ${password}`);

    let formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    setIsLoading(true);

    axios.post(loginUrl, formData).then(async (fetchResponse) => {
      console.log(fetchResponse);
      // const authData = (await fetchResponse.json());
      const authData = fetchResponse.data.authDetails;

      if(authData.idToken) {
        setIdToken(authData.idToken);
        setIsLoggedIn(true);
        setPasswordShouldBeSet(false);

        sessionStorage.setItem('auth-username', username);
        sessionStorage.setItem('auth-id-token', authData.idToken);
        sessionStorage.setItem('auth-refresh-token', authData.refreshToken);
      } else if(authData.challengeParameters) {
        setAuthChallengeParameters(authData.challengeParameters);
        setAuthChallengeSession(authData.session);

        setIsLoggedIn(false);
        setPasswordShouldBeSet(true);
      } else {
        setIsLoggedIn(false);
        setPasswordShouldBeSet(false);
      }

      setIsLoading(false);
    }).catch(e => {
      console.error(`WUT (${e})`);
      setIsLoading(false);
    });
  };

  const handleChallengePasswordSubmit = e => {
    e.preventDefault();

    if((challengePassword1 == '') || (challengePassword1 !== challengePassword2)) {
      return false;
    }

    // Do something with the form values
    console.log(`Password: ${password}`);

    console.log(`authDetails (${JSON.stringify(authChallengeParameters)})`);
    // let formData = new FormData();
    // formData.append('username', authChallengeParameters.USER_ID_FOR_SRP); //JSON.parse(authChallengeParameters.userAttributes).email);
    // formData.append('password', challengePassword1);
    // formData.append('newPassword', challengePassword2);
    // formData.append('authToken', authChallengeSession);

    const challengePayload = JSON.stringify({
      'username': authChallengeParameters.USER_ID_FOR_SRP,
      'password': challengePassword1,
      'newPassword': challengePassword2,
      'authToken': authChallengeSession,
    });

    setIsLoading(true);

    axios.post(challengeUrl, challengePayload).then(async (fetchResponse) => {
      console.log(fetchResponse);
      // const authData = (await fetchResponse.json());
      const authData = fetchResponse.data;
      console.log(`authData (${authData})`);

      if(authData.IdToken) {
        setIdToken(authData.IdToken);
        setIsLoggedIn(true);
        setPasswordShouldBeSet(false);

        sessionStorage.setItem('auth-username', authChallengeParameters.USER_ID_FOR_SRP);
        sessionStorage.setItem('auth-id-token', authData.IdToken);
        sessionStorage.setItem('auth-refresh-token', authData.RefreshToken);
      } else {
        setIsLoggedIn(false);
        setPasswordShouldBeSet(false);
      }

      setIsLoading(false);
    }).catch(e => {
      console.error(`WUT (${e})`);
      setIsLoading(false);
    });
  };

  // if(isLoading) {
  //   return (
  //     <div>
  //       <h1>Loading...</h1>
  //       <CircleLoader size="50px" loading={isLoading} />
  //     </div>
  //   );
  // }

  if(passwordShouldBeSet) {
    return (
      <LoadingOverlay
        active={isLoading}
        spinner
        text='Loading your content...'
      >
        <div>
          Please set a decent password: letters, numbers, at least 10 chars, an exclamation mark and 123 at the end.
          <form onSubmit={handleChallengePasswordSubmit}>
            <label>
              Password:
              <input
                name="password1"
                type="password"
                onChange={e => setChallengePassword1(e.target.value)}
              />
            </label>
            <label>
              Confirm Password:
              <input
                name="password2"
                type="password"
                onChange={e => setChallengePassword2(e.target.value)}
              />
            </label>            <br />
            <button type="submit">Set Password</button>
          </form>
        </div>
      </LoadingOverlay>
    );
  } else {
    return (
      <LoadingOverlay
        active={isLoading}
        spinner
        text='Loading your content...'
      >
        <div>
          <form onSubmit={handleSubmit}>
            <label>
              UserName:
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </label>
            <br />
            <label>
              Password:
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </label>
            <br />
            <div>
            <button type="submit">Log In</button>
            </div>
          </form>
        </div>
      </LoadingOverlay>
    );
  }
};

export default LoginPage;
